import { render, staticRenderFns } from "./CameraModule.vue?vue&type=template&id=c810373a&scoped=true"
import script from "./CameraModule.vue?vue&type=script&lang=js"
export * from "./CameraModule.vue?vue&type=script&lang=js"
import style0 from "./CameraModule.vue?vue&type=style&index=0&id=c810373a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c810373a",
  null
  
)

export default component.exports